import { atom } from 'recoil';

import routes from '@/shared/routes';
import { RoutesType } from '@/shared/types/route.type';

export const currentRouteState = atom<RoutesType>({
  key: 'currentRouteState',
  default: routes[0],
});
